module.exports = __webpack_public_path__ + "img/calendar-time-rose.71665a57.svg";